import React, { useState, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import FuturesAndOptionsFaq from '../../pages/markets/component/futures-and-options-faq';
import DetailPageHeader from '../../pages/markets/component/detail-page-header';
import FuturesExternalSearch from '../../pages/markets/component/futures-external-search';
import SectoralMovementsFuturesExternal from '../../pages/markets/component/sectoral-movements-futures-external';
import '../../pages/markets/pages/futures-external-sectoral-movements/futures-external-sectoral-movements.m.css';

const SectoralMovementsFull = () => {
  const queryClient = new QueryClient();
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <>
        {initialLoading ? (
          <div styleName="initial-loading-container"></div>
        ) : (
          <div styleName="detail-header-container">
            <div className="container">
              <DetailPageHeader />
            </div>
          </div>
        )}

        <div styleName="overall-container">
          <div styleName="search-widget-container" className="container">
            <FuturesExternalSearch />

            <SectoralMovementsFuturesExternal />
          </div>
        </div>
        <div className="container">
          <FuturesAndOptionsFaq />
        </div>
      </>
    </QueryClientProvider>
  );
};

export default SectoralMovementsFull;
